import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=7105bea5&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=7105bea5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7105bea5",
  null
  
)

export default component.exports